import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numeral',
  standalone: false
})
export class NumeralPipe implements PipeTransform {
  constructor(private readonly numberPipe: DecimalPipe) {}

  public transform(value: number, word: string, suffix = 's'): string {
    return value === 1
      ? `${this.numberPipe.transform(value, '1.0-0').replace(/,/g, '')} ${word}`
      : `${this.numberPipe.transform(value, '1.0-0').replace(/,/g, '')} ${word}${suffix}`;
  }
}
